import React from 'react';

const StudyLogsPage: React.FunctionComponent<any> = () => {
  return (
    <div>
      <h3>StudyLogs Page</h3>
    </div>
  );
};

export default StudyLogsPage;
